export function CompletionTagSkeleton() {
  return (
    <div
      className="w-5 h-5 rounded-full bg-gray-200 flex-shrink-0"
      style={{ minWidth: '1.25rem', minHeight: '1.25rem' }}
      aria-hidden="true"
    />
  )
}

export function BookmarkSkeleton() {
  return (
    <div
      className="w-5 h-5 rounded bg-gray-200 flex-shrink-0"
      style={{ minWidth: '1.25rem', minHeight: '1.25rem' }}
      aria-hidden="true"
    />
  )
}

export function BlockContentSkeleton({ aspectRatio = '16/9' }: { aspectRatio?: string }) {
  return (
    <div
      className="w-full bg-gray-100 rounded-lg"
      style={{ aspectRatio, minHeight: '400px' }}
      aria-hidden="true"
    />
  )
}
